export const ordersKey = {
  all: ['orders'] as const,
  orderGroups: (keyword?: string) => [...ordersKey.all, keyword, 'orderGroups'] as const,
  get: (id: string) => [...ordersKey.all, id, 'order'] as const,
  getV1: (id: string) => [...ordersKey.all, id, 'orderV1'] as const,
  list: (search?: string) => [...ordersKey.all, search ?? '', 'list'] as const,
};
